import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';

import dishSerializer from './serializer.js';

// ============ GET DISH DETAIL ============
bus.on(constants.EVENTS.DISH.DISH_DETAILS_REQUESTED, (payload) => {
  const requestId = `dishDetail-${Date.now()}`;

  if (!payload?.id) {
    bus.emit(constants.EVENTS.DISH.DISH_DETAIL_ERROR, {
      message: 'Dish ID is required'
    });
    return;
  }

  bus.emit(constants.EVENTS.DISH.DISH_DETAIL_LOADING);

  const url = constants.ENDPOINTS.DISHES.DETAIL.replace('{id}', payload.id);

  bus.emit('network.request', {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  // Use bus.once to avoid listener accumulation and auto-cleanup
  bus.on('network.response', (res) => {
    if (res.id === requestId) {
      if (res.success) {
        // Extract raw data format depending on wrapper ({data: {data: ...}} or {data: ...})
        const apiData = res.data?.data || res.data;
        const decodedDish = dishSerializer.deserializeDish(apiData);
        bus.emit(constants.EVENTS.DISH.DISH_DETAIL_LOADED, decodedDish);
      } else {
        const error = dishSerializer.deserializeError(res);
        bus.emit(constants.EVENTS.DISH.DISH_DETAIL_ERROR, error);
      }
    }
  });
});

